<template>
  <div
    draggable="true"
    @dragstart="onDragStart"
    @click.stop="$emit('click', post)"
    :class="[color.bg, color.text, color.darkBg, color.darkText]"
    class="text-[11px] px-1.5 py-0.5 rounded truncate cursor-grab active:cursor-grabbing"
    :title="post.keyword">
    <span :class="[color.dot]" class="inline-block w-1.5 h-1.5 rounded-full mr-1 align-middle" />
    {{ post.keyword }}
  </div>
</template>

<script setup>
const props = defineProps({
  post: { type: Object, required: true },
  color: { type: Object, required: true }
})

defineEmits(['click'])

function onDragStart(e) {
  e.dataTransfer.effectAllowed = 'move'
  e.dataTransfer.setData('application/json', JSON.stringify({
    postId: props.post.id,
    originalDate: props.post.scheduled_date
  }))
}
</script>
